<form
	#form="ngForm"
	(ngSubmit)="onSubmit(form)"
	class="flex flex-col h-full"
	[appAtLeastOneRequired]="[
		'pinNumber',
		'unitNumber',
		'unitType',
		'levelNumber',
		'condoPlan',
		'legalDescription',
	]"
>
	<div class="pt-6 pb-8 px-6 overflow-auto grow">
		<div class="flex flex-col gap-6">
			<ui-checkbox
				label="Primary {{ isCondoUnit ? 'Unit' : 'Parcel' }}"
				name="condoPrimary"
				[(ngModel)]="title.primary"
				[testHook]="testHooks.CondoPrimaryCheckbox"
			/>

			<app-input
				[labelToolTip]="
					matchingPinNumber
						? 'This PIN is synced directly from a Teranet search. To enter a new PIN, delete this record and complete a new search.'
						: ''
				"
				[labelIcon]="matchingPinNumber ? ICON.QUESTION : ''"
				label="PIN"
				[disabled]="!!matchingPinNumber"
				[(ngModel)]="title.pinNumber"
				pin-format
				[submitted]="form.submitted"
				[name]="'pinNumber'"
				[testHook]="testHooks.Pin"
			></app-input>

			@if (isCondoUnit) {
				<app-select
					class="col-span-2"
					name="unitType"
					label="Unit Type"
					[(ngModel)]="title.unitType"
					(ngModelChange)="onUnitTypeSelect($event)"
					[submitted]="form.submitted"
					[testHook]="testHooks.UnitTypeSelect"
				>
					@for (unitType of unitTypes; track unitType) {
						<option [value]="unitType" [testHook]="testHooks.Option">
							{{ unitType }}
						</option>
					}
				</app-select>

				<app-input
					label="Unit No."
					[(ngModel)]="title.unitNumber"
					[submitted]="form.submitted"
					[name]="'unitNumber'"
					[testHook]="testHooks.UnitNo"
				></app-input>

				<app-input
					label="Level No."
					[(ngModel)]="title.levelNumber"
					[submitted]="form.submitted"
					[name]="'levelNumber'"
					[testHook]="testHooks.LevelNo"
				></app-input>
			} @else {
				<app-input
					label="Lot"
					[(ngModel)]="title.lot"
					[submitted]="form.submitted"
					[name]="'unitNumber'"
					[testHook]="testHooks.Lot"
				></app-input>
			}

			<app-input
				name="condoPlan"
				[label]="isCondoUnit ? 'Condo Plan' : 'Plan'"
				[(ngModel)]="title.planName"
				[testHook]="testHooks.CondoPlan"
			></app-input>

			<div class="flex flex-col gap-4">
				<div class="flex flex-col" *ngIf="matchingPinNumber">
					<div class="pt-2 pb-1">
						<img
							src="assets/images/teranet-logo.jpg"
							style="width: 100px; height: 15px"
						/>
					</div>
					<div
						#teranetLegalDescContainer
						class="p-4 w-full rounded-xl bg-grey-lightest"
					>
						{{ matchingPinNumber?.legal_desc }}
					</div>
				</div>

				<div class="flex flex-col">
					<div>
						<app-text-area
							[height]="legalDescTextAreaHeight()"
							[rows]="3"
							label="{{
								matchingPinNumber ? 'Customize' : 'Legal'
							}} description"
							*ngIf="!forceRerender"
							name="legalDescription"
							[(ngModel)]="title.legalDescription"
							[testHook]="testHooks.LegalDescriptionTextArea"
						>
						</app-text-area>
					</div>

					<div
						class="flex justify-between gap-6 mt-2"
						*ngIf="
							matchingPinNumber &&
							matchingPinNumber?.legal_desc !== title.legalDescription
						"
					>
						<p>Legal description different from Teranet description</p>

						<div
							class="text-blue-light flex cursor-pointer"
							(click)="syncLegalDescription()"
							[testHook]="testHooks.SyncLegalDescriptionDiv"
						>
							<div class="mr-2">
								<app-icon
									[icon]="ICON.REFRESH"
									[testHook]="testHooks.RefreshIcon"
								></app-icon>
							</div>
							Sync
						</div>
					</div>
				</div>
			</div>

			<p
				*ngIf="form.submitted && form.errors?.atLeastOneRequired"
				class="text-red p-sm"
			>
				At least one of the above fields are required.
			</p>

			@if (isCondoUnit) {
				<div class="grid grid-cols-2 gap-x-4 gap-y-6">
					<label>Common expenses</label>
					<app-input
						type="cents"
						name="commonExpenses"
						[(ngModel)]="title.commonExpenses"
						(ngModelChange)="onCommonExpensesChange($event)"
						[startIcon]="ICON.DOLLAR"
						[testHook]="testHooks.CommonExpenses"
					></app-input>

					@if (showApplyHstCheckbox()) {
						<ui-checkbox
							label="Apply HST ({{ hstPercentage | percent }})"
							name="applyHst"
							[(ngModel)]="title.applyHst"
							(ngModelChange)="onApplyHstChange($event)"
							[testHook]="testHooks.ApplyHstCheckbox"
						/>
						<div class="flex justify-end font-normal text-sm">
							{{ commonExpensesHstAmt() | centsToDollars }}
						</div>

						<hr class="col-span-2" />

						<div>Total</div>
						<div class="flex justify-end font-medium text-sm">
							{{ commonExpensesGrandTotal() | centsToDollars }}
						</div>
					}
				</div>
			}
		</div>
	</div>

	<div class="p-6">
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Save"
			type="submit"
			[testHook]="testHooks.SaveButton"
		></ui-button>
	</div>
</form>
